module.exports = __webpack_public_path__ + "static/media/creditCardIcon.70e90e25.svg";